import classNames from "classnames";
import styles from './index.module.scss';
import { Row, Col } from 'antd';
import UserLine from './userLine';
import ApiRank from './apiRank';
import ResourceTotal from './resourceTotal';
import ResourceProport from './resourceProport';
import UserIp from "./userIp";
import { useState, useEffect } from "react";
import { getAllCount } from '@/apis/statistics'
const DataStatistics = () => {
	const [total, setTotal] = useState(0)
	const [allCount, setAllCount] = useState(0);
	const [onlineUser, setOnlineUser] = useState(0)
	useEffect(() => {
		// const socket = new WebSocket('ws://10.101.240.70:11010/management/ws/onlineUser');
		const socket = new WebSocket('wss://ogeoa.net/management/ws/onlineUser');
		socket.onopen = () => {
			console.log('WebSocket Connected');
		};

		socket.onmessage = (event) => {
			const res = JSON.parse(event.data);
			setOnlineUser(res.onlineUserCount)
		};

		socket.onerror = (error) => {
			console.error('WebSocket Error: ', error);
		};

		socket.onclose = () => {
			console.log('WebSocket Disconnected');
		};
		getAllCount().then(res=>{
			setAllCount(res.data)
		})
		// 清理函数，用于在组件卸载时关闭WebSocket连接
		return () => {
			socket.close();
		};
	}, [])

	return <div className={classNames('container', styles.dataStatisticsBox)}>

		<Row gutter={15}>
			<Col span={12}>
				<div className={styles.colBox}>
					<div className={styles.titleBox}>当前在线用户<span>{onlineUser}</span><i>人</i>   /  总注册数<span>{allCount}</span><i>人</i></div>
					<UserLine />
				</div>
			</Col>
			<Col span={12}>
				<div className={styles.colBox}>
					<div className={styles.titleBox}>流量分析：当月接口访问次数排名</div>
					<ApiRank />
				</div>
			</Col>
			<Col span={8}>
				<div className={styles.colBox}>
					<div className={styles.titleBox}>当前资源总量<span>{total}</span><i>条</i></div>
					<ResourceTotal setTotal={setTotal} />
				</div>
			</Col>
			<Col span={8}>
				<div className={styles.colBox}>
					<div className={styles.titleBox}>各类资源占比</div>
					<ResourceProport />
				</div>
			</Col>
			<Col span={8}>
				<div className={styles.colBox}>
					<div className={styles.titleBox}>当月用户IP分布</div>
					<UserIp />
				</div>
			</Col>
		</Row>
	</div>;
}
export default DataStatistics;